import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

export const getIngredients = async ({
  page = 1,
  limit = 25,
  ingredientIds,
  name,
  category,
  sector,
  isActive,
  includeAllStatuses,
  signal,
} = {}) => {
  const query = qs({ page, limit, ingredientIds: ingredientIds?.join?.(",") || ingredientIds, name, category, sector, isActive, includeAllStatuses });
  return httpClient.get(`/stock/ingredients${query}`, { signal });
};

export const getIngredient = async (ingredientId, { signal } = {}) => {
  if (!ingredientId) throw new Error("El ID del insumo es requerido");
  return httpClient.get(`/stock/ingredients/${ingredientId}`, { signal });
};

export const getIngredientCatalog = async ({
  page = 1,
  limit = 100,
  name,
  category,
  sector,
  signal,
} = {}) => {
  const query = qs({ page, limit, name, category, sector });
  return httpClient.get(`/stock/ingredient-catalog${query}`, { signal });
};

export const getIngredientCatalogCategories = async ({ sector, signal } = {}) => {
  const query = qs({ sector });
  return httpClient.get(`/stock/ingredient-catalog/categories${query}`, { signal });
};

export const activateIngredientCatalogItems = async (catalogItemIds) => {
  return httpClient.post('/stock/ingredient-catalog/activate', { catalogItemIds });
};

export const createIngredient = async (data) => {
  return httpClient.post("/stock/ingredients", data);
};

export const patchIngredient = async (ingredientId, data) => {
  if (!ingredientId) throw new Error("El ID del insumo es requerido");
  return httpClient.patch(`/stock/ingredients/${ingredientId}`, data);
};

export const activateIngredientStock = (ingredientIds) =>
  httpClient.post('/stock/ingredients/activate-stock', { ingredientIds });
